import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Youtube, Clock } from "lucide-react";
import { business, hours } from "../data/mock";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-5 py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <span className="flex items-center justify-center w-10 h-10 rounded-xl bg-gradient-to-br from-sky-500 to-sky-600 text-white font-heading font-bold text-lg">F</span>
            <span className="font-heading font-bold text-white text-lg">Fred Mustica</span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">
            Honest, local tech help since {business.since} — plus photography, licensed drone work and hand-built FPV parts.
          </p>
          <a href={business.youtube} target="_blank" rel="noreferrer" className="mt-4 inline-flex items-center gap-2 text-sm text-slate-300 hover:text-white transition-colors">
            <Youtube size={18} className="text-red-500" /> MrFredMustica on YouTube
          </a>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-white mb-4">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
            <li><Link to="/photography" className="hover:text-white transition-colors">Photography</Link></li>
            <li><Link to="/drone" className="hover:text-white transition-colors">Drone Work</Link></li>
            <li><Link to="/fpv" className="hover:text-white transition-colors">FPV Jack Point Covers</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-white mb-4">Get in touch</h4>
          <ul className="space-y-3 text-sm">
            <li><a href={business.phoneHref} className="flex items-center gap-2 hover:text-white transition-colors"><Phone size={16} className="text-sky-400" /> {business.phone}</a></li>
            <li><a href={business.emailHref} className="flex items-center gap-2 hover:text-white transition-colors"><Mail size={16} className="text-sky-400" /> {business.email}</a></li>
            <li className="flex items-start gap-2"><MapPin size={16} className="text-sky-400 mt-0.5" /> {business.address}</li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-white mb-4 flex items-center gap-2"><Clock size={16} className="text-sky-400" /> Opening Hours</h4>
          <ul className="space-y-1.5 text-sm">
            {hours.map((h) => (
              <li key={h.day} className="flex justify-between gap-4">
                <span className="text-slate-400">{h.day}</span>
                <span className={h.open ? "text-slate-200" : "text-slate-500"}>{h.time}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-5 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} {business.name}. All rights reserved.</p>
          <p>Please call the mobile only — landline is unplugged. Leave a message if I'm busy.</p>
        </div>
      </div>
    </footer>
  );
}
